
import { defineComponent } from 'vue'
import { createValidations } from '@/helpers/commons/validationHelper'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'
import driversManagemenDetailtDescriptor from './DriversManagementDetailDescriptor.json'
import driversManagemenValidationtDescriptor from './DriversManagementValidationDescriptor.json'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
export default defineComponent({
    name: 'detail-card',
    components: { Dropdown, MultiSelect, KnValidationMessages },
    props: {
        selectedDriver: {
            type: Object,
            required: false
        },
        types: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            driver: {} as any,
            driversManagemenDetailtDescriptor,
            driversManagemenValidationtDescriptor,
            selectedOptions: [] as String[],
            v$: useValidate() as any
        }
    },
    validations() {
        const validationObject = {
            driver: createValidations('driver', driversManagemenValidationtDescriptor.validations.driver)
        }
        return validationObject
    },
    watch: {
        selectedDriver() {
            this.driver = this.selectedDriver as any
            this.handleTypes()
        }
    },
    mounted() {
        if (this.driver) {
            this.driver = this.selectedDriver as any
            this.handleTypes()
        }
    },
    methods: {
        handleTypes() {
            this.selectedOptions = []
            if (this.driver.functional) {
                this.selectedOptions.push('functional')
            }
            if (this.driver.temporal) {
                this.selectedOptions.push('temporal')
            }
        },
        changeType() {
            this.selectedOptions.includes('temporal') ? (this.driver.temporal = true) : (this.driver.temporal = false)
            this.selectedOptions.includes('functional') ? (this.driver.functional = true) : (this.driver.functional = false)
            this.setDirty()
        },
        setDirty() {
            this.$emit('touched')
        }
    }
})
